export default __webpack_public_path__ + "static/media/LilNounClassroomEmpty.363245a6.png";